import { supabase } from '../supabaseClient';

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

const sameInstant = (left, right) => {
  if (left === null && right === null) return true;
  const leftMs = Date.parse(left || '');
  const rightMs = Date.parse(right || '');
  return Number.isFinite(leftMs) && Number.isFinite(rightMs) && leftMs === rightMs;
};

export async function finalizeFollowupMilestones({
  clientId,
  consultationOrdinal,
  completePastAppointment = false,
  expectedNextRdvAt = null,
  reviewStepNumber = null,
  db = supabase,
} = {}) {
  const normalizedClientId = String(clientId || '').trim();
  if (!UUID_RE.test(normalizedClientId)) {
    throw new Error('La fiche SaaS de la cliente est introuvable.');
  }
  if (!Number.isInteger(consultationOrdinal) || consultationOrdinal < 1) {
    throw new Error('La consultation relue est introuvable.');
  }
  if (completePastAppointment !== true && reviewStepNumber === null) {
    throw new Error('Aucun rendez-vous ni point de suivi à finaliser.');
  }
  if (completePastAppointment === true && !Number.isFinite(Date.parse(expectedNextRdvAt || ''))) {
    throw new Error('La date du rendez-vous passé est invalide.');
  }
  if (reviewStepNumber !== null && (!Number.isInteger(reviewStepNumber) || reviewStepNumber < 1)) {
    throw new Error('Le point de suivi choisi est invalide.');
  }

  const { data, error } = await db.rpc(
    'finaliser_jalons_suivi_apres_consultation_atomiquement',
    {
      p_client_id: normalizedClientId,
      p_consultation_ordinal: consultationOrdinal,
      p_complete_past_rdv: completePastAppointment === true,
      p_expected_next_rdv_at: completePastAppointment ? expectedNextRdvAt : null,
      p_review_step_number: reviewStepNumber,
    },
  );
  if (error) throw new Error(error.message || 'Les jalons du suivi n’ont pas pu être finalisés.');
  if (
    data?.ok !== true
    || data?.client_id !== normalizedClientId
    || data?.consultation_ordinal !== consultationOrdinal
    || data?.completed_review_step_number !== reviewStepNumber
    || !Array.isArray(data?.pack_schedule)
    || !data?.journey_state
    || (completePastAppointment && !sameInstant(data?.cleared_next_rdv_at, expectedNextRdvAt))
  ) {
    throw new Error('La finalisation du suivi n’a pas été confirmée par le serveur.');
  }
  return data;
}
